module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	"use strict";

	fox.registerWidget('Popup_Common', {

		configure: function () {
			this.registerOptions('', {
				widget: 'Dialog',
				template: '',
				additionalClasses: '',
				useUiPosition: true,
				dialog: {
					dialogClass: 'mc-site-common-popup',
					autoOpen: false,
					closeText: '',
					closeOnEscape: false,
					draggable: true,
					width: 'auto'
				},
				widgets: {
					content: {
						widget: 'Widget',
						template: 'div.popup-content',
						autoRender: true,
						container: '#popup-widget-container',
						'handleDom.close': {
							target: '.close',
							callback: '@parent:hide'
						},
						'handleDom.cloneOnParent' :{
							target: '.close',
							targetWidget: '@parent',
							callback: '@parent:hide'
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.setOption('dialog.dialogClass', [this.getOption('dialog.dialogClass'), this.getOption('additionalClasses')].join(' '));

			this.callParent('init', arguments);
		}
	}, 'Dialog');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/popup/commonPopup.js
// module id = 881
// module chunks = 4